import React, { useState, useRef, useEffect } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import axios from 'helpers/api';
import * as mapYourMedsConstant from '../../../common/mapYourMedsConstant.js';

const MedFrequencyForm = (props) => {

    const initialFormData = {
        frequency: "",
        isactive: true,
        id: ""
    };

    const [formData, setFormData] = useState(initialFormData);
    const [buttonStatus, setButtonStatus] = useState(mapYourMedsConstant.ADD_ACTION);
    const formRef = useRef(null);
    //const navigate = useNavigate();

    useEffect(() => {
        if (props.edittrigger > 0 && props.medfreqvalue) {
          const { frequency, is_active, frequency_id } = props.medfreqvalue;
      
          setFormData({
            frequency: frequency || "",
            isactive: is_active == 1 || is_active === true, // normalize boolean
            id: frequency_id || ""
          });
      
          setButtonStatus(mapYourMedsConstant.UPDATE_ACTION);
        }
      }, [props.edittrigger, props.medfreqvalue]);
      

    const handleSubmit = async e => {
        e.preventDefault();

        //console.log("ActiveFormData" + formData.isactive ? 1 : 0)

        let tokenStr = localStorage.getItem("accessToken");
        let pelmedsMedFreqUrl = buttonStatus == "Add" ? `${process.env.REACT_APP_SERVER_URL}` + "/prescriptions/add-prescription-frequency/" : `${process.env.REACT_APP_SERVER_URL}` + "/prescriptions/update-prescription-frequency/";
        let pelmedsMedFreqData = buttonStatus == "Add" ? { "name": formData.frequency,"group_id" : localStorage.getItem("groupId") || '', "is_active": formData.isactive ? 1 : 0 } :
            { "name": formData.frequency,"group_id" : localStorage.getItem("groupId") || '', "is_active": formData.isactive ? 1 : 0, "id": formData.id }

        //console.log("pelmedsMedFreqData " + JSON.stringify(pelmedsMedFreqData));

        const { data } = await axios.post(pelmedsMedFreqUrl, pelmedsMedFreqData, { headers: { 'Authorization': `Bearer ${tokenStr}` } });

        if (data.status) {
            toast.success("MedFrequency added successfully");
            //navigate(0);
        }
        else {
            toast.info("Error while adding MedFrequency");
        }

        //if (buttonStatus != "Edit") {
        setFormData(initialFormData);
        formRef.current.reset();
        setButtonStatus("Add");
        //}

        props.onCallParent();

    };

    const handleFieldChange = e => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    return (
        <Form ref={formRef} onSubmit={handleSubmit}>
            <Row>
                <Col xs={6}>
                    <Form.Group className="mb-3">
                        <Form.Label className="required">Frequency Name</Form.Label>
                        <Form.Control
                            placeholder='Frequency Name'
                            value={formData.frequency}
                            name="frequency"
                            size="sm"
                            onChange={handleFieldChange}
                            type="text"
                        />
                    </Form.Group>
                </Col>
                <Col xs={6}>
                    <Form.Group>
                        <Button
                            type="submit"
                            color="primary"
                            size="sm"
                            className="mt-4 w-50"
                            disabled={!formData.frequency}>
                            {buttonStatus}
                        </Button>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    <Form.Group>
                        <Form.Check
                            type='switch'
                            name="isactive"
                            id='isactive'
                            checked={
                                formData.isactive
                            }
                            onChange={e =>
                                setFormData({
                                    ...formData,
                                    isactive: e.target.checked
                                })
                            }
                            label='Active'
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Label><span className="text-danger">*</span> indicates required field</Form.Label>
                </Col>
            </Row>
        </Form>
    );
};
export default MedFrequencyForm;

